export default __webpack_public_path__ + "static/media/sc.0ae428ce.svg";